module.exports = __webpack_public_path__ + "img/face38.087eaf16.gif";